import { makeStyles } from '@material-ui/core';
import StatusDot from '../components/StatusDot';
import { LabProcessStatus } from '../hooks/useKits';
import CustomTooltip from './CustomTooltip';

interface TestNameProps {
    status: LabProcessStatus | string;
    children?: React.ReactNode;
    onClick?: () => void;
    variant: 'dashboard' | 'member';
}

const TestName = ({ status, children, onClick, variant }: TestNameProps) => {
    const classes = useStyles();

    return (
        <div className={classes.testName} onClick={onClick}>
            <StatusDot status={status} />
            {variant === 'member' && (
                <>
                    <CustomTooltip
                        title="Click to view details and progress"
                        placement="right"
                        variant="light"
                    >
                        <div className={classes.member}>{children}</div>
                    </CustomTooltip>
                </>
            )}
            {variant === 'dashboard' && (
                <div className={classes.dashboard}>{children}</div>
            )}
        </div>
    );
};

const useStyles = makeStyles((theme) => ({
    testName: {
        display: 'flex',
        alignItems: 'center',
        gap: 19,
    },
    member: {
        color: theme.palette.primary.main,
        fontFamily: 'Cairo',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '150%',
        textDecorationLine: 'underline',
        textDecorationStyle: 'solid',
        textDecorationSkipInk: 'none',
        textDecorationThickness: 'auto',
        textUnderlineOffset: 'auto',
        textUnderlinePosition: 'from-font',
    },
    dashboard: {
        color: theme.palette.primary.main,
        fontFamily: 'Noto Sans',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '120%,' /* 19.2px */,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        maxWidth: '220px',
    },
}));

export default TestName;
